import { Component, input } from "@angular/core";
import { FieldTree, FormField } from "@angular/forms/signals";
import { EstateTypeModel, EstateTypesFilterModel } from "./search-filter-estate-types.model";

@Component({
    selector: "search-filter-estate-types",
    imports: [FormField],
    templateUrl: "./search-filter-estate-types.component.html",
    styleUrl: "./search-filter-estate-types.component.scss",
})
export class SearchFilterEstateTypesComponent {
    filterForm = input.required<FieldTree<EstateTypesFilterModel>>();

    toggleExpanded(): void {
        this.filterForm().expanded().value.set(!this.filterForm().expanded().value());
    }
    toggleSelectedEstate(estateType: EstateTypeModel): void {
        const current = this.filterForm().estateTypes().value();
        this.filterForm()
            .estateTypes()
            .value.set(current.map((e) => (e.index === estateType.index ? { ...e, selected: !e.selected } : e)));
    }

    selectAllEstateTypes(): void {
        if (this.checkIfAllSelected()) {
            this.filterForm()
                .estateTypes()
                .value.update((estateTypes: EstateTypeModel[]) => {
                    return estateTypes.map((estateType) => {
                        return {
                            ...estateType,
                            selected: false,
                        };
                    });
                });
        } else {
            this.filterForm()
                .estateTypes()
                .value.update((estateTypes: EstateTypeModel[]) => {
                    return estateTypes.map((estateType) => {
                        return {
                            ...estateType,
                            selected: true,
                        };
                    });
                });
        }
    }

    private checkIfAllSelected(): boolean {
        return this.filterForm()
            .estateTypes()
            .value()
            .every((estateType) => estateType.selected);
    }
}
